import { useState } from 'react';
import { Alert, Button, Group, Modal, Stack, Text, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useCustomerDisplay } from './CustomerDisplayProvider';
import { openDisplayWindow } from './openDisplayWindow';

export function CustomerDisplayModal({ opened, onClose }: { opened: boolean; onClose: () => void }) {
  const { t } = useTranslation('CustomerDisplay');
  const { identity, restore, status } = useCustomerDisplay();
  const [previousLink, setPreviousLink] = useState('');
  const [showRestore, setShowRestore] = useState(false);
  const [message, setMessage] = useState('');
  const url = identity ? `${location.origin}/customer-display/${identity.displayId}` : '';
  return <Modal opened={opened} onClose={onClose} title={t('title')} centered>
    <Stack>
      <Text size="sm">{t('linkHelp')}</Text>
      <TextInput label={t('link')} value={url} readOnly data-private="true" className="ph-no-capture sentry-mask" />
      <Text size="sm" c="dimmed">{t(`connection.${status}`)}</Text>
      <Group grow>
        <Button disabled={!url} onClick={async () => {
          try { await navigator.clipboard.writeText(url); setMessage('copied'); } catch { setMessage('copyFailed'); }
        }}>{t('copy')}</Button>
        <Button disabled={!url} variant="light" onClick={async () => setMessage(await openDisplayWindow(url) === 'blocked' ? 'popupBlocked' : 'windowHelp')}>{t('open')}</Button>
      </Group>
      <Text size="sm" c="dimmed">{t('windowHelp')}</Text>
      <Button variant="subtle" onClick={() => setShowRestore(!showRestore)}>{t('restore')}</Button>
      {showRestore && <Stack>
        <Text size="sm">{t('restoreHelp')}</Text>
        <TextInput label={t('previousLink')} value={previousLink} onChange={(event) => setPreviousLink(event.currentTarget.value)} className="ph-no-capture sentry-mask" />
        <Button variant="light" onClick={async () => {
          try { await restore(previousLink); setPreviousLink(''); setShowRestore(false); setMessage('restored'); }
          catch { setMessage('restoreFailed'); }
        }}>{t('restore')}</Button>
      </Stack>}
      {message && <Alert role="status">{t(message)}</Alert>}
    </Stack>
  </Modal>;
}
